import {Injectable, signal, WritableSignal} from '@angular/core';
import {STORAGE} from '../constants/storage.constants';
import {UsersModel} from '../models/users.model';

@Injectable({ providedIn: 'root' })
export class UserService {

  user: WritableSignal<UsersModel | undefined> = signal(
    sessionStorage.getItem(STORAGE.USER)
      ? JSON.parse(atob(sessionStorage.getItem(STORAGE.USER)!))
      : undefined
  );
  updateUser(newValue: UsersModel): void {
    this.user.set(newValue);
    sessionStorage.setItem(STORAGE.USER, btoa(JSON.stringify(newValue)));
  }

  isLogged(): boolean {
    return !!this.user;
  }

  loggedUser(): string {
    return this.user()!.username;
  }

}
